export const productsTranslations = {
  en: {
    'products.addProduct': 'Add New Product',
    'products.addProductDesc': 'Create a new product for your catalog',
    'products.productInfo': 'Product Information',
    'products.name': 'Product Name',
    'products.namePlaceholder': 'Enter product name',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'Enter SKU (optional)',
    'products.price': 'Price',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Status',
    'products.status.active': 'Active',
    'products.status.inactive': 'Inactive',
    'products.status.draft': 'Draft',
    'products.category': 'Category',
    'products.categoryPlaceholder': 'Select a category',
    'products.description': 'Description',
    'products.descriptionPlaceholder': 'Enter product description',
    'products.adding': 'Adding...',
    'products.add': 'Add Product',
    'products.toast.error': 'Error',
    'products.toast.errorDesc': 'Please fill in all required fields',
    'products.toast.success': 'Success',
    'products.toast.successDesc': 'Product added successfully',
    'products.toast.fail': 'Failed to add product',
  },
  es: {
    'products.addProduct': 'Añadir Nuevo Producto',
    'products.addProductDesc': 'Crea un nuevo producto para tu catálogo',
    'products.productInfo': 'Información del Producto',
    'products.name': 'Nombre del Producto',
    'products.namePlaceholder': 'Introduce el nombre del producto',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'Introduce el SKU (opcional)',
    'products.price': 'Precio',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Estado',
    'products.status.active': 'Activo',
    'products.status.inactive': 'Inactivo',
    'products.status.draft': 'Borrador',
    'products.category': 'Categoría',
    'products.categoryPlaceholder': 'Selecciona una categoría',
    'products.description': 'Descripción',
    'products.descriptionPlaceholder': 'Introduce la descripción del producto',
    'products.adding': 'Añadiendo...',
    'products.add': 'Añadir Producto',
    'products.toast.error': 'Error',
    'products.toast.errorDesc': 'Por favor, rellena todos los campos obligatorios',
    'products.toast.success': 'Éxito',
    'products.toast.successDesc': 'Producto añadido correctamente',
    'products.toast.fail': 'No se pudo añadir el producto',
  },
  fr: {
    'products.addProduct': 'Ajouter un nouveau produit',
    'products.addProductDesc': 'Créez un nouveau produit pour votre catalogue',
    'products.productInfo': 'Informations sur le produit',
    'products.name': 'Nom du produit',
    'products.namePlaceholder': 'Entrez le nom du produit',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'Entrez le SKU (optionnel)',
    'products.price': 'Prix',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Statut',
    'products.status.active': 'Actif',
    'products.status.inactive': 'Inactif',
    'products.status.draft': 'Brouillon',
    'products.category': 'Catégorie',
    'products.categoryPlaceholder': 'Sélectionnez une catégorie',
    'products.description': 'Description',
    'products.descriptionPlaceholder': 'Entrez la description du produit',
    'products.adding': 'Ajout...',
    'products.add': 'Ajouter le produit',
    'products.toast.error': 'Erreur',
    'products.toast.errorDesc': 'Veuillez remplir tous les champs obligatoires',
    'products.toast.success': 'Succès',
    'products.toast.successDesc': 'Produit ajouté avec succès',
    'products.toast.fail': 'Échec de l\'ajout du produit',
  },
  sq: {
    'products.addProduct': 'Shto Produkt të Ri',
    'products.addProductDesc': 'Krijoni një produkt të ri për katalogun tuaj',
    'products.productInfo': 'Informacioni i Produktit',
    'products.name': 'Emri i Produktit',
    'products.namePlaceholder': 'Shkruani emrin e produktit',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'Shkruani SKU (opsionale)',
    'products.price': 'Çmimi',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Statusi',
    'products.status.active': 'Aktiv',
    'products.status.inactive': 'Joaktiv',
    'products.status.draft': 'Draft',
    'products.category': 'Kategoria',
    'products.categoryPlaceholder': 'Zgjidhni një kategori',
    'products.description': 'Përshkrimi',
    'products.descriptionPlaceholder': 'Shkruani përshkrimin e produktit',
    'products.adding': 'Duke shtuar...',
    'products.add': 'Shto Produkt',
    'products.toast.error': 'Gabim',
    'products.toast.errorDesc': 'Ju lutemi plotësoni të gjitha fushat e kërkuara',
    'products.toast.success': 'Sukses',
    'products.toast.successDesc': 'Produkti u shtua me sukses',
    'products.toast.fail': 'Dështoi shtimi i produktit',
  },
  ru: {
    'products.addProduct': 'Добавить новый продукт',
    'products.addProductDesc': 'Создайте новый продукт для вашего каталога',
    'products.productInfo': 'Информация о продукте',
    'products.name': 'Название продукта',
    'products.namePlaceholder': 'Введите название продукта',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'Введите SKU (необязательно)',
    'products.price': 'Цена',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Статус',
    'products.status.active': 'Активен',
    'products.status.inactive': 'Неактивен',
    'products.status.draft': 'Черновик',
    'products.category': 'Категория',
    'products.categoryPlaceholder': 'Выберите категорию',
    'products.description': 'Описание',
    'products.descriptionPlaceholder': 'Введите описание продукта',
    'products.adding': 'Добавление...',
    'products.add': 'Добавить продукт',
    'products.toast.error': 'Ошибка',
    'products.toast.errorDesc': 'Пожалуйста, заполните все обязательные поля',
    'products.toast.success': 'Успех',
    'products.toast.successDesc': 'Продукт успешно добавлен',
    'products.toast.fail': 'Не удалось добавить продукт',
  },
  pt: {
    'products.addProduct': 'Adicionar Novo Produto',
    'products.addProductDesc': 'Crie um novo produto para seu catálogo',
    'products.productInfo': 'Informações do Produto',
    'products.name': 'Nome do Produto',
    'products.namePlaceholder': 'Digite o nome do produto',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'Digite o SKU (opcional)',
    'products.price': 'Preço',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Status',
    'products.status.active': 'Ativo',
    'products.status.inactive': 'Inativo',
    'products.status.draft': 'Rascunho',
    'products.category': 'Categoria',
    'products.categoryPlaceholder': 'Selecione uma categoria',
    'products.description': 'Descrição',
    'products.descriptionPlaceholder': 'Digite a descrição do produto',
    'products.adding': 'Adicionando...',
    'products.add': 'Adicionar Produto',
    'products.toast.error': 'Erro',
    'products.toast.errorDesc': 'Por favor, preencha todos os campos obrigatórios',
    'products.toast.success': 'Sucesso',
    'products.toast.successDesc': 'Produto adicionado com sucesso',
    'products.toast.fail': 'Falha ao adicionar produto',
  },
  el: {
    'products.addProduct': 'Προσθήκη Νέου Προϊόντος',
    'products.addProductDesc': 'Δημιουργήστε ένα νέο προϊόν για τον κατάλογό σας',
    'products.productInfo': 'Πληροφορίες Προϊόντος',
    'products.name': 'Όνομα Προϊόντος',
    'products.namePlaceholder': 'Εισάγετε όνομα προϊόντος',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'Εισάγετε SKU (προαιρετικό)',
    'products.price': 'Τιμή',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Κατάσταση',
    'products.status.active': 'Ενεργό',
    'products.status.inactive': 'Ανενεργό',
    'products.status.draft': 'Προσχέδιο',
    'products.category': 'Κατηγορία',
    'products.categoryPlaceholder': 'Επιλέξτε κατηγορία',
    'products.description': 'Περιγραφή',
    'products.descriptionPlaceholder': 'Εισάγετε περιγραφή προϊόντος',
    'products.adding': 'Προσθήκη...',
    'products.add': 'Προσθήκη Προϊόντος',
    'products.toast.error': 'Σφάλμα',
    'products.toast.errorDesc': 'Παρακαλώ συμπληρώστε όλα τα υποχρεωτικά πεδία',
    'products.toast.success': 'Επιτυχία',
    'products.toast.successDesc': 'Το προϊόν προστέθηκε με επιτυχία',
    'products.toast.fail': 'Αποτυχία προσθήκης προϊόντος',
  },
  de: {
    'products.addProduct': 'Neues Produkt hinzufügen',
    'products.addProductDesc': 'Erstellen Sie ein neues Produkt für Ihren Katalog',
    'products.productInfo': 'Produktinformationen',
    'products.name': 'Produktname',
    'products.namePlaceholder': 'Produktname eingeben',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'SKU eingeben (optional)',
    'products.price': 'Preis',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Status',
    'products.status.active': 'Aktiv',
    'products.status.inactive': 'Inaktiv',
    'products.status.draft': 'Entwurf',
    'products.category': 'Kategorie',
    'products.categoryPlaceholder': 'Kategorie auswählen',
    'products.description': 'Beschreibung',
    'products.descriptionPlaceholder': 'Produktbeschreibung eingeben',
    'products.adding': 'Hinzufügen...',
    'products.add': 'Produkt hinzufügen',
    'products.toast.error': 'Fehler',
    'products.toast.errorDesc': 'Bitte füllen Sie alle Pflichtfelder aus',
    'products.toast.success': 'Erfolg',
    'products.toast.successDesc': 'Produkt erfolgreich hinzugefügt',
    'products.toast.fail': 'Produkt konnte nicht hinzugefügt werden',
  },
  ro: {
    'products.addProduct': 'Adaugă Produs Nou',
    'products.addProductDesc': 'Creați un produs nou pentru catalogul dvs.',
    'products.productInfo': 'Informații Produs',
    'products.name': 'Nume Produs',
    'products.namePlaceholder': 'Introduceți numele produsului',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'Introduceți SKU (opțional)',
    'products.price': 'Preț',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Status',
    'products.status.active': 'Activ',
    'products.status.inactive': 'Inactiv',
    'products.status.draft': 'Ciornă',
    'products.category': 'Categorie',
    'products.categoryPlaceholder': 'Selectați o categorie',
    'products.description': 'Descriere',
    'products.descriptionPlaceholder': 'Introduceți descrierea produsului',
    'products.adding': 'Se adaugă...',
    'products.add': 'Adaugă Produs',
    'products.toast.error': 'Eroare',
    'products.toast.errorDesc': 'Vă rugăm completați toate câmpurile obligatorii',
    'products.toast.success': 'Succes',
    'products.toast.successDesc': 'Produs adăugat cu succes',
    'products.toast.fail': 'Nu s-a putut adăuga produsul',
  },
  sr: {
    'products.addProduct': 'Додај нови производ',
    'products.addProductDesc': 'Креирајте нови производ за ваш каталог',
    'products.productInfo': 'Информације о производу',
    'products.name': 'Назив производа',
    'products.namePlaceholder': 'Унесите назив производа',
    'products.sku': 'СКУ',
    'products.skuPlaceholder': 'Унесите СКУ (опционо)',
    'products.price': 'Цена',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Статус',
    'products.status.active': 'Активан',
    'products.status.inactive': 'Неактиван',
    'products.status.draft': 'Нацрт',
    'products.category': 'Категорија',
    'products.categoryPlaceholder': 'Изаберите категорију',
    'products.description': 'Опис',
    'products.descriptionPlaceholder': 'Унесите опис производа',
    'products.adding': 'Додавање...',
    'products.add': 'Додај производ',
    'products.toast.error': 'Грешка',
    'products.toast.errorDesc': 'Молимо попуните сва обавезна поља',
    'products.toast.success': 'Успех',
    'products.toast.successDesc': 'Производ успешно додат',
    'products.toast.fail': 'Додавање производа није успело',
  },
  pl: {
    'products.addProduct': 'Dodaj Nowy Produkt',
    'products.addProductDesc': 'Utwórz nowy produkt do swojego katalogu',
    'products.productInfo': 'Informacje o Produkcie',
    'products.name': 'Nazwa Produktu',
    'products.namePlaceholder': 'Wprowadź nazwę produktu',
    'products.sku': 'SKU',
    'products.skuPlaceholder': 'Wprowadź SKU (opcjonalnie)',
    'products.price': 'Cena',
    'products.pricePlaceholder': '0.00',
    'products.status': 'Status',
    'products.status.active': 'Aktywny',
    'products.status.inactive': 'Nieaktywny',
    'products.status.draft': 'Szkic',
    'products.category': 'Kategoria',
    'products.categoryPlaceholder': 'Wybierz kategorię',
    'products.description': 'Opis',
    'products.descriptionPlaceholder': 'Wprowadź opis produktu',
    'products.adding': 'Dodawanie...',
    'products.add': 'Dodaj Produkt',
    'products.toast.error': 'Błąd',
    'products.toast.errorDesc': 'Proszę wypełnić wszystkie wymagane pola',
    'products.toast.success': 'Sukces',
    'products.toast.successDesc': 'Produkt dodany pomyślnie',
    'products.toast.fail': 'Nie udało się dodać produktu',
  },
};
